(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-content"] && !Shopify.designMode) return;
  try {
    
/* ⚠️ JS statico: nessun Liquid qui dentro */
(function () {
  var INIT_ATTR = 'data-seo-initialized';

  function getCollapsedPx(el) {
    var v = getComputedStyle(el).getPropertyValue('--collapsed').trim();
    if (!v) return 160;
    if (v.endsWith('px')) v = v.slice(0, -2);
    var n = parseInt(v, 10);
    return isNaN(n) ? 160 : n;
  }

  function setupBlock(block) {
    if (!block || block.getAttribute(INIT_ATTR) === 'true') return;

    var enabled = String(block.getAttribute('data-seo-enabled')) !== 'false';
    var text = block.querySelector('[data-seo-text]');
    var btn  = block.querySelector('[data-seo-toggle]');
    if (!text || !btn) return;

    // Nasconde completamente il bottone se disabilitato da settings
    if (!enabled) {
      btn.style.display = 'none';
      text.classList.add('is-expanded');
      block.setAttribute(INIT_ATTR, 'true');
      return;
    }

    var labelMore = block.getAttribute('data-label-more') || 'LEGGI DI PIÙ';
    var labelLess = block.getAttribute('data-label-less') || 'LEGGI DI MENO';

    function applyState() {
      var collapsedMax = getCollapsedPx(text);
      var isOverflowing = text.scrollHeight > collapsedMax + 10;
      if (!isOverflowing) {
        btn.style.display = 'none';
        text.classList.remove('is-expanded');
        return;
      } else {
        btn.style.display = '';
      }
    }

    text.classList.remove('is-expanded');
    btn.textContent = labelMore;
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var expanded = text.classList.toggle('is-expanded');
      btn.textContent = expanded ? labelLess : labelMore;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    var resizeObs = new ResizeObserver(applyState);
    resizeObs.observe(text);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(applyState);
    }

    requestAnimationFrame(applyState);
    setTimeout(applyState, 400);

    block.setAttribute(INIT_ATTR, 'true');
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-seo]').forEach(setupBlock);
  }

  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', function(){ init(); });
  window.addEventListener('load', function(){ init(); }, { passive: true });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });

  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if (n.nodeType === 1) init(n);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
